module.exports = __webpack_public_path__ + "img/newMessage.8606c4e2.svg";